el-image<template>
  <div>
    <table class="common-table mt20">
      <thead>
        <tr>
          <th v-for="data in theadData">
            {{ data }}
          </th>
          <!-- <th>操作</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td class="common-add">{{ index + 1 }}</td>
          <td class="common-add">
            <el-tooltip class="item" effect="dark" :content="item.certificate_no" placement="left-start">
              <span>{{ item.certificate_no }}</span>
            </el-tooltip>
          </td>
          <td class="common-add">
            <el-tooltip class="item" effect="dark" :content="item.co_name" placement="left-start">
              <span>{{ item.co_name }}</span>
            </el-tooltip>
          </td>
          <td class="common-add">
            <el-tooltip class="item" effect="dark" :content="item.co_phone" placement="left-start">
              <span>{{ item.co_phone }}</span>
            </el-tooltip>
          </td>
          <td class="common-add" style="display: grid;">
            <div v-if="item.certificate_url && item.certificate_url.length > 0" v-for="url of item.certificate_url">
              <el-image style="width: 200px;height: 200px;" :src="url" fit="contain"></el-image>
            </div>
          </td>
          <td class="common-add">
            <el-tooltip class="item" effect="dark" :content="item.company_name" placement="left-start">
              <span>{{ item.company_name }}</span>
            </el-tooltip>
          </td>
          <!--           
                  <td class="common-add">

                     <div v-if="input.type == 'select'">
                      <v-select :value.sync="
                        form[tabList[index1].form][index][input.form_name]
                      " @changeValue="changeSelect" :id="input.op_id || input.option" :pid="input.pid"
                        :formName="input.form_name" :index="index" :curObj="curObj"
                        :nowObj="form[tabList[index1].form][index]"></v-select>
                    </div>
                    <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                      v-model="form[tabList[index1].form][index][input.form_name]"
                      v-else-if="input.type == 'date'"></el-date-picker>
                    <el-time-picker type="time" value-format="HH:mm:ss" placeholder="选择时间"
                      v-model="form[tabList[index1].form][index][input.form_name]"
                      v-else-if="input.type == 'timmer'"></el-time-picker>
                    <imageUpload v-else-if="input.type == 'uploadImg'" :fileUrl="'/oss/file/uploadFileFlag'"
                      v-model="form[tabList[index1].form][index][input.form_name]" />

                    <el-input placeholder="请输入" v-model="form[tabList[index1].form][index][input.form_name]" v-else
                      :type="input.type"></el-input> 
                  </td>
                  <td class="td-btn">
                    <a class="clear-data" @click="del(index)">
                      <i class="icon-tr-delete"></i>
                    </a>
                  </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return { theadData: ["序号", "证书编号", "姓名", "电话", "上传证书", "单位名称"], data: [] };
  },
  mounted() {
    this.$get("/trxf/main/xf/getOperatorDutyGroup").then((res) => {
      console.log(res);
      this.data = res.data.map((item) => {
        if (item.certificate_url) {
          item.certificate_url = item.certificate_url.split(",");
        }
        return item;
      });
      this.data.certificate_url ? (this.data.certificate_url = this.data.certificate_url.split(",")) : "";
      console.log(this.data);
    });
  },
};
</script>
<style scoped lang="scss">
.common-table > tbody > tr > td {
  border: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  color: #666;
}
</style>
